import { createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { ServiceBillRepository } from '~/repositories/serviceBillRepository';
import type { AddServiceBillDto, AdjustServiceBillDto } from '~/swagger/portal/Api';
const repo = new ServiceBillRepository();

export const [ServiceBillProvider, useServiceBill] = createMagicDoorContext('serviceBill', () => {
  const [filtered, setFilter, actions] = createTriggerResource((filter: any) => repo.getServiceBills(filter));

  const addServiceBill = createMutation(async (data: AddServiceBillDto) => {
    return await repo.addServiceBill(data);
  });

  const updateServiceBill = createMutation(async (billId: string, data: AdjustServiceBillDto) => {
    await repo.updateServiceBill(billId, data);
    actions.refetch();
  });

  const getServiceBill = createMutation(async (serviceBillId: string) => {
    return await repo.getServiceBill(serviceBillId);
  });

  const deleteServiceBill = createMutation(async (serviceBillId: string) => {
    await repo.deleteServiceBill(serviceBillId);
    actions.refetch();
  });

  return {
    filtered,
    setFilter,
    addServiceBill,
    updateServiceBill,
    deleteServiceBill,
    getServiceBill,
    actions,
  };
});
